import React from 'react';
import { motion } from 'framer-motion';
export function FinalStats() {
  return <section className="w-full py-16 px-4 bg-gradient-to-r from-[#5C1A1B] via-[#7A2325] to-[#5C1A1B] border-y border-[#D4AF37]/20" data-id="element-134">
      <div className="max-w-6xl mx-auto" data-id="element-135">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 text-center divide-x-0 md:divide-x divide-white/20" data-id="element-136">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex flex-col items-center" data-id="element-137">
            <span className="font-playfair text-3xl sm:text-4xl text-white font-bold mb-2" data-id="element-138">
              10,000+
            </span>
            <span className="font-inter text-xs sm:text-sm text-[#D4AF37] uppercase tracking-widest font-semibold" data-id="element-139">
              Clientas
            </span>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="flex flex-col items-center" data-id="element-140">
            <span className="font-playfair text-3xl sm:text-4xl text-white font-bold mb-2" data-id="element-141">
              74+
            </span>
            <span className="font-inter text-xs sm:text-sm text-[#D4AF37] uppercase tracking-widest font-semibold" data-id="element-142">
              Países
            </span>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="flex flex-col items-center" data-id="element-143">
            <span className="font-playfair text-3xl sm:text-4xl text-white font-bold mb-2" data-id="element-144">
              4.93/5
            </span>
            <span className="font-inter text-xs sm:text-sm text-[#D4AF37] uppercase tracking-widest font-semibold" data-id="element-145">
              Calificación
            </span>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="flex flex-col items-center" data-id="element-146">
            <span className="font-playfair text-3xl sm:text-4xl text-white font-bold mb-2" data-id="element-147">
              89%
            </span>
            <span className="font-inter text-xs sm:text-sm text-[#D4AF37] uppercase tracking-widest font-semibold" data-id="element-148">
              Precisión
            </span>
          </motion.div>
        </div>
      </div>
    </section>;
}